/* eslint-disable camelcase */
import { CoveoProductInfo, CoveoProductModel } from "@DSG/Type/CoveoModels";
import { getProductCollectionRealTimeInventory, GetProductCollectionRealTimeInventoryApiV2Parameter, getProductCollectionRealTimePrices } from "@insite/client-framework/Services/ProductServiceV2";
import { ProductInventoryDto, ProductPriceDto } from "@insite/client-framework/Types/ApiModels";
// import ApplicationState from "@insite/client-framework/Store/ApplicationState";
// import { ProductPriceDto } from "@insite/client-framework/Types/ApiModels";



export const getRealTimePricing = async (products: any) => {
    const apiParameter: any = [];
    products.forEach((item: any) => {
        if(item.productId !=""){
            apiParameter.push({
                productId: item.productId,
                unitOfMeasure: 'ea',
                qtyOrdered: 1,
                productDetailPath:`/p/${item.productNumber}`
            });
        }
    });
    try {
        const result = await getProductCollectionRealTimePrices({ productPriceParameters: apiParameter });
        return result;
    } catch (error) {
        console.error("Error occurred >>:", error);
    }
};

export const updateRealTimePricingForProducts = (products: CoveoProductModel[], realTimePricing: ProductPriceDto[]) => {
    if (realTimePricing && realTimePricing.length) {
        return products.map((p: any) => {
           // const product = structuredClone(p);
            const currentProduct = realTimePricing.find(item => item.productId === p.productId.toLowerCase());
            if (currentProduct) {
                p.pricing = currentProduct;
            }
            return p;
        });
    }
    return products;
};

export const updatePreviousPurchaseDateForProduct = (products: CoveoProductModel[], coveoProductsData:any) => {
    
    return products.map((p: any) => {
        const prevProduct = coveoProductsData.find((item: { productNumber: any; }) => p.productNumber !==null &&  item.productNumber && item.productNumber.toLowerCase() === p.productNumber.toLowerCase());
            if (prevProduct) {
                p.previousPurchaseDate = prevProduct.previouslyPurchaseDate;
                p.productId = prevProduct.productId;
                p.badges = prevProduct.badges;
            }
        return p;
    });

    // return products;
};


export const getRealTimeInventory = async (products: any) => {
    const apiParameter: GetProductCollectionRealTimeInventoryApiV2Parameter = {
        productIds: [],
        configurations: {},
        expand: [],
    };
    products.forEach((item: any) => {
        if(item.productId !=""){
            apiParameter.productIds.push(item.productId);
        }
    });
    try {
        const result = await getProductCollectionRealTimeInventory(apiParameter);
        return result;
    } catch (error) {
        console.error("Error occurred >>:", error);
    }
};

export const updateRealTimeInventoryForProducts = (products: CoveoProductModel[], realTimeInventory: ProductInventoryDto[]) => {
    if (realTimeInventory && realTimeInventory.length) {
        return products.map((p: any) => {
           // const product = structuredClone(p);
            const currentProduct = realTimeInventory.find(item => item.productId === p.productId.toLowerCase());
            if (currentProduct) {
                p.inventory = currentProduct;
            }
            return p;
        });
    }
    return products;
};

export const updateOrderQtyorProducts = (product: CoveoProductInfo, productId: string,orderQty:number) => {
    if (product) {
        if(product.productId === productId){
                product.qtyOrdered=orderQty
            }
            return product;
    }
    return product;
};